import { FC } from 'react';
import useIsOutdatedBrowser from '@components/features/outdatedBrowser/hooks/useIsOutdatedBrowser';
import { useTranslation } from 'react-i18next';

const OutdatedBrowserMessage: FC = () => {
    const isOutdatedBrowser = useIsOutdatedBrowser();
    const { t } = useTranslation();

    if (!isOutdatedBrowser) {
        return null;
    }

    return (
        <div className="outdatedBrowser__message">
            <div className="container">
                <h3>{t('outdatedBrowser.message.title')}</h3>
                <p>{t('outdatedBrowser.message.text')}</p>
            </div>
        </div>
    );
};

export default OutdatedBrowserMessage;
